import React from 'react';
import PricingPlanForm from './widgets/PricingPlanForm';

export default function AddPricingPlanScreen() {
  return <PricingPlanForm mode="create" />;
}
